module.exports = __webpack_public_path__ + "media/src/images/balloons/womans_day_headline_de-2979c323e47b15c35df7417db0dce4b7.png";